import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxHttpLoaderModule } from 'ngx-http-loader';
import { CoreModule } from './core/core.module';
import { MessageModule } from './kernel/tools/message/message.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DashboardModule } from "src/app/applications/dashboard/dashboard.module";
import { AuthenticationModule } from "src/app/applications/authentication/authentication.module";
import { AdminModule } from './applications/admin/admin.module';
import { loadLocale } from './core/locale';
import { LocalStorageService } from './kernel/tools/services/local-storage.service';
import { NotificationModule } from './kernel/notifications/notification.module';
import { DashboardLayoutModule } from './shared/layout/dashboard-layout/dashboard-layout.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AuthService } from './kernel/tools/services/auth.service';
import { AuthService as AppAuthService } from './core/services/auth.service';
import { ManagementModule } from './applications/management/management.module';
import { JwtInterceptor } from "./core/interceptors/jwt.interceptor";
import { SharedActionsModule } from './shared/components/shared-action -module';
import { MajorClientsComponent } from './shared/components/major-clients/major-clients.component';
import { MajorSuppliersComponent } from './shared/components/major-suppliers/major-suppliers.component';


// ===================== SUB APPLICATIONS { =====================

// ===================== } SUB APPLICATIONS =====================

@NgModule({
  declarations: [AppComponent, MajorClientsComponent, MajorSuppliersComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxHttpLoaderModule.forRoot(),
    CoreModule,
    MessageModule,
    BrowserAnimationsModule,
    AuthenticationModule,
    DashboardModule,
    AdminModule,
    ManagementModule,
    DashboardLayoutModule,
    SharedActionsModule,
    NotificationModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    { provide: AuthService, useExisting: AppAuthService },
    {
      provide: LOCALE_ID,
      useFactory: loadLocale,
      deps: [LocalStorageService],
    },
    {
      provide: LOCALE_ID,
      useFactory: loadLocale,
      deps: [LocalStorageService]
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'AED',
    },

  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
